/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import FeaturesBar from "./FeaturesBar";
import {WealthyEnv} from "helpers";

const FeaturesBarContainer = () => {
  const CDN = WealthyEnv.BROKING_CDN_URL;

  const featuresList = [
    {
      icon: `${CDN}/investing-icon.png`,
      context: "Curated Investing"
    },
    {
      icon: `${CDN}/digitised-icon.png`,
      context: "Completely Digitalised"
    },
    {
      icon: `${CDN}/bank-icon.png`,
      context: "Bank Grade Security"
    },
    {
      icon: `${CDN}/help-center-icon.png`,
      context: "Help Centers"
    }
  ];

  return (
    <FeaturesBar featuresList={featuresList} />
  );
};

export default FeaturesBarContainer;
